import React, { useEffect, useContext, useState } from 'react'
// import { Link } from "react-router-dom"
import { StateController } from './../../App'

import VerticalCenter from '../../layouts/VerticalCenter/VerticalCenter'
import Input from '../atoms/Input'
import Button from '../atoms/Button'
import Icon from '../atoms/Icon'
import { sendDataLayer } from '../../utils/functions'

function CustomModal({
  show,
  setShowModal,
  primaryAction,
  secondaryAction,
  terms,
  image,
  title,
  desc,
  cta,
  twoStepAuth,
  showErrorRedemtion,
  showSuccessRedemtion,
  redemtion,
  position,
  isAwardTerms,
  general,
  setTwoStepString,
  showErrorDate,
  winner,
  className,
  enabledButton = true,
  endImage
}) {
  const { setMdalOpen } = useContext(StateController)
  const [twoStepAuthStatus, setTwoStepAuthStatus] = useState(false)
  const [expDate, setExpDate] = useState('')
  const [localErrorDate, setLocalErrorDate] = useState(false)

  const [errors, setErrors] = useState({
    expDate: false
  })

  useEffect(() => {
    if (showErrorDate) {
      setLocalErrorDate(true)
      setTwoStepAuthStatus(false) // ← resetea también el status
    }
  }, [showErrorDate])

  useEffect(() => {

    setMdalOpen(show ? true : false)
  }, [show])

  const close = () => {
    if (winner) {
      sendDataLayer({datalayer: {event: 'cancel_modal_bonus', index: position},repeat: true})
    } 
    setShowModal(false)
  }

  const handleChange = async (e) => {    
    const element = e.target.getAttribute('rel') 

    if (element === 'birthdate') {
      setExpDate(e.target.value)
      setTwoStepString(e.target.value)
      setErrors({ ...errors, expDate: false})

      setTwoStepAuthStatus(true)
      setLocalErrorDate(false)
      console.log('twoStepAuthStatus', twoStepAuthStatus)
      console.log('showErrorDate', showErrorDate)
      showErrorDate = false

      console.log('-showErrorDate', showErrorDate)
    }
  }
  
  return (
    <div className={`mc-custom-modal ${show && 'mc-custom-modal__opened'} slow_ani ${className ? className : ''}`}>
      <div className="mc-custom-modal__overlay slow_ani" onClick={close}></div>
      <div className={`mc-custom-modal__center ${isAwardTerms ? 'extended' : ''} ${general ? 'generalModal' : ''} ${winner ? 'winnerModal' : ''}`}>
        <VerticalCenter>
          <div className="mc-custom-modal__center--window slow_ani">
            <div className="mc-custom-modal__close" onClick={close}>
              <Icon name="close" />
            </div>
                        
              {
                redemtion || isAwardTerms?
                <>
              <div className={`modal_header_content ${showErrorRedemtion ? 'modalError' : ''}`}>
              {(image && !showErrorRedemtion && !showSuccessRedemtion) &&
                <div
                className="mc-custom-modal__center--window__image"
                style={{"backgroundImage": `url(/assets/images/${image})`}}
                >
                </div>
              }
              {!isAwardTerms &&
                <div className="header_modal_title">
                  <div className="mc-custom-modal__center--window__desc">
                    <div dangerouslySetInnerHTML={{ __html: desc }} />
                  </div>
                  {
                    (!showErrorRedemtion && !showSuccessRedemtion) &&
                    <div className="mc-custom-modal__center--window__title v1"><span>USD {title}</span></div>

                  }
                </div>
              }
              {isAwardTerms &&
                <div className="header_modal_title">
                  <div className="mc-custom-modal__center--window__desc">
                    {title}
                  </div>
                </div>
              }
              {winner &&
                <div>
                  <div className={`mc-custom-modal__center--window__title ${status && 'status'}`}>
                    <div dangerouslySetInnerHTML={{ __html: title }} />
                  </div>
                </div>
              }

            </div> 

            {isAwardTerms &&
              <div>
                <div dangerouslySetInnerHTML={{ __html: desc }} />
              </div>
            }           

            {twoStepAuth &&
              <div className="mc-custom-modal__center--window__auth">
                <h4 className='title_auth'>Validación de seguridad</h4>
                <p className='text_auth'>Para descargar tu e-Gift Card ingresa la siguiente información:</p>

                <Input 
                  type={'birthdate'}
                  label={'Fecha de nacimiento'}
                  placeholder={'DD/MM/AAAA'}
                  onChange={handleChange}
                  inputByCharacter={false}
                  maxlength={10}
                  value={expDate}
                  error={errors.expDate || showErrorDate}
                />
              </div>
            }
            {showErrorDate &&
              <div className='text_danger_date'>
                <Icon name='danger' />
                <span className='danger_text'>Fecha errónea, por favor verifica la información ingresada y vuelve a intentarlo.</span>
                
              </div>
            }
            <div className="mc-custom-modal__center--window__actions">
              <Button
                type="primary"
                text={primaryAction ? primaryAction.buttonText : cta}
                loading={primaryAction ? primaryAction.loading : false}
                status={twoStepAuth ? twoStepAuthStatus === true && !localErrorDate ? `active` : 'inactive' : 'active'}
                onClick={primaryAction ? primaryAction.action : close}
                icon={twoStepAuth && !(twoStepAuthStatus === true && !localErrorDate) ? 'lock.svg' : false}
                showErrorRedemtion={showErrorRedemtion}
              />
              {secondaryAction &&
                <Button
                  type="secondary"
                  text={secondaryAction.buttonText}
                  loading={false}
                  status="active"
                  onClick={secondaryAction.action}                 
                />
              }
            </div>
            {terms &&
              <div className="mc-custom-modal__center--window__terms">
                {/* <Link to={terms.termsLink} target="_blank">
                  {terms.termsText}
                </Link> */}
              </div>
            }
            {
              !isAwardTerms && (!showErrorRedemtion && !showSuccessRedemtion) &&
              <div className="tyc_copy">
                Las e-Gift Cards están sujetas a términos y condiciones de cada comercio aliado, los cuales se especifican en la e-Gift Card que se redime y descarga en la plataforma.
              </div>
            }
                </>

                :

                general &&

                <>
              <div className={`modal_header_content ${showErrorRedemtion ? 'modalError' : ''}`}>
              {(image && !showErrorRedemtion && !showSuccessRedemtion) &&
                <div
                className="mc-custom-modal__center--window__image"
                style={{"backgroundImage": `url(/assets/images/${image})`}}
                >
                </div>
              }
              {!isAwardTerms &&
                <div className="header_modal_title">
                  <div className="mc-custom-modal__center--window__title v2"><span>{title}</span></div>

                  <div className="mc-custom-modal__center--window__desc">
                    <div dangerouslySetInnerHTML={{ __html: desc }} />
                  </div>
                </div>
              }
              {(endImage) &&
                <div className="mc-custom-modal__center--window__end_image">
                  <img src={`../assets/images/${endImage}`} alt="" />
                </div>
              }
        

            </div> 

            

         
              {enabledButton &&
                <div style={{width:'70%',margin:'0 auto'}} className="mc-custom-modal__center--window__actions">
                  <Button
                    type="primary"
                    text={primaryAction ? primaryAction.buttonText : cta}
                    loading={primaryAction ? primaryAction.loading : false}
                    status={twoStepAuth ? twoStepAuthStatus === true ? `active` : 'inactive' : 'active'}
                    onClick={primaryAction ? primaryAction.action : close}                
                    showErrorRedemtion={showErrorRedemtion}
                  />
                  {secondaryAction &&
                    <Button
                      type="secondary"
                      text={secondaryAction.buttonText}
                      loading={false}
                      status="active"
                      onClick={secondaryAction.action}                 
                    />
                  }
                </div>
              }
            
           
    
                </>
              }

          </div>
        </VerticalCenter>
      </div>
    </div>
  )
}

export default CustomModal
